import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import MetricNineBoxesServices from "./MetricNineBoxes.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMetricNineBoxes = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: true,
    });
    let resp;
    if(filters.filter&& filters.filter!==""){
      resp = await MetricNineBoxesServices.getMetricNineBoxes(filters);
    }
    const respAll = await MetricNineBoxesServices.getMetricNineBoxes({});
    let temp = {data:[]};
    respAll&&respAll.data.data.map((item)=>{
      if(!temp.data.find(t=>t.anio===item.anio)){
        temp.data.push(item)
      }
    })
    dispatch({
      type: actions.GET_METRIC_NINE_BOXES,
      payload: {
        metricNineBoxes:filters.filter&& filters.filter!==""?resp.data:{data:[],count:0},
        metricNineBoxesAll:respAll.data,
        metricNineBoxesAnio:temp
      },
    });
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: false,
    });
  }
};

export const resetMetricNineBoxes = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: true,
    });
    dispatch({
      type: actions.GET_METRIC_NINE_BOXES,
      payload: {
        metricNineBoxes:{data:[],count:0},
        metricNineBoxesAll:{data:[],count:0},
        metricNineBoxesAnio:{data:[]}
      },
    });
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: false,
    });
  }
};

export const saveMetricNineBoxes = (req, setShowModal, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_METRIC_NINE_BOXES,
      payload: true,
    });
    const resp = await MetricNineBoxesServices.saveMetricNineBoxes(req);
    const { data, count } = getState().metricNineBoxes.metricNineBoxes;
    const { data: dataAll, count: countAll } = getState().metricNineBoxes.metricNineBoxesAll;
    const { data: dataAnio } = getState().metricNineBoxes.metricNineBoxesAnio;
    const _data = [...data, resp.data];
    const _dataAll = [...dataAll, resp.data];
    let _dataAnio = dataAnio
    if(!_dataAnio.find(t=>t.anio===resp.data.anio)){
      _dataAnio.push(resp.data)
    }
    if(_data[count]){
      setInicialValorMinimo(_data[count].valor_maximo + 1)
    }else{
      setInicialValorMinimo(0)
    }

    dispatch({
      type: actions.GET_METRIC_NINE_BOXES,
      payload: {
        metricNineBoxes:{count: count + 1,data: _data},
        metricNineBoxesAll:{count: countAll + 1,data: _dataAll},
        metricNineBoxesAnio: {data: _dataAnio}
      },
    });
    dispatch({
      type: actions.FORM_METRIC_NINE_BOXES_FAIL,
      payload: "",
    });
    setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_METRIC_NINE_BOXES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_METRIC_NINE_BOXES,
      payload: false,
    });
  }
};

export const editMetricNineBoxes = (req, index, setShowModal, offset) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_METRIC_NINE_BOXES,
        payload: true,
      });
      const resp = await MetricNineBoxesServices.editMetricNineBoxes(req.id, req);
      const { data, count } = getState().metricNineBoxes.metricNineBoxes;
      const { data: dataAll, count: countAll } = getState().metricNineBoxes.metricNineBoxesAll;
      const { data: dataAnio } = getState().metricNineBoxes.metricNineBoxesAnio;
      let _data = data.slice();
      let _dataAll = dataAll.slice();
      _data[index] = resp.data;
      _dataAll[index+offset] = resp.data;
      if(index<2 && data[index+1]){
        const _req = {
          valor_minimo: parseInt(req.valor_maximo) + 1,
          valor_maximo: data[index+1].valor_maximo,
          tipo_criterio: data[index+1].tipo_criterio,
          descripcion: data[index+1].descripcion
        }
        const _resp = await MetricNineBoxesServices.editMetricNineBoxes(data[index+1].id, _req);
        _data[index+1] = _resp.data;
      }
      dispatch({
        type: actions.GET_METRIC_NINE_BOXES,
        payload: {
          metricNineBoxes:{data: _data,count: count},
          metricNineBoxesAll:{data: _dataAll,count: countAll},
          metricNineBoxesAnio: {data: dataAnio}
        },
      });
      dispatch({
        type: actions.FORM_METRIC_NINE_BOXES_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_METRIC_NINE_BOXES_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_METRIC_NINE_BOXES,
        payload: false,
      });
    }
  };

export const deleteMetricNineBoxes = (id, index, offset, setInicialValorMinimo) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: true,
    });
    await MetricNineBoxesServices.deleteMetricNineBoxes(id);
    const { data, count } = getState().metricNineBoxes.metricNineBoxes;
    const { data: dataAll, count: countAll } = getState().metricNineBoxes.metricNineBoxesAll;
    const { data: dataAnio } = getState().metricNineBoxes.metricNineBoxesAnio;
    let _data = data.slice();
    let _dataAll = dataAll.slice();
    let _dataAnio = dataAnio.slice();

    if(_data[index+1]){
      const _data1 = {
        valor_minimo:_data[index].valor_minimo
      }
      const _resp = await MetricNineBoxesServices.editMetricNineBoxes(_data[index+1].id, _data1);
      if(index+1){
        _data[index+1] = _resp.data;
      }
      _dataAll[index+offset+1] = _resp.data;
    }
    _data.splice(index, 1);
    _dataAll.splice(index+offset, 1);

    if(_data[count-2]){
      setInicialValorMinimo(_data[count-2].valor_maximo)
    }else{
      setInicialValorMinimo(0)
    }

    dispatch({
      type: actions.GET_METRIC_NINE_BOXES,
      payload: {
        metricNineBoxes:{data: _data,count: count - 1},
        metricNineBoxesAll:{data: _dataAll,count: countAll - 1},
        metricNineBoxesAnio: {data: dataAnio}
      },
    });
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.METRIC_NINE_BOXES_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRIC_NINE_BOXES,
      payload: false,
    });
  }
};
